import { redirect } from 'react-router-dom'
import { fetchPublicCampaign, fetchPublicCampaignPosts, resumePublicCampaignShares } from '../apis/public-campaign'
import { LOAD_POSTS_LIMIT, PUBLIC_CAMPAIGN_TAB } from '../constants'
import { publicCampaignPagePath } from '../links'

export async function loadPublicCampaignPageData({ params, request }) {
  const campaignToken = params.campaignToken
  const requestedTab = new URL(request.url).searchParams.get('tab')
  const tab = Object.values(PUBLIC_CAMPAIGN_TAB).includes(requestedTab) ? requestedTab : PUBLIC_CAMPAIGN_TAB.NEW

  const { campaign, error, status } = await fetchPublicCampaign({ campaignToken })
  if (status === 404) {
    return { notFound: true }
  }
  if (error) throw new Error(error)

  // visitors who are not logged in can see only the new posts
  const currentTab = campaign.Viewer?.LoggedIn ? tab : PUBLIC_CAMPAIGN_TAB.NEW
  const { posts, error: postsError } = await fetchPublicCampaignPosts({ campaignToken, tab: currentTab, limit: LOAD_POSTS_LIMIT, offset: 0 })
  if (postsError) throw new Error(postsError)

  return { campaign, posts, tab: currentTab }
}

// loadPublicCampaignPageResumeData shares the pending shares once the visitor returns after logging in with LinkedIn
export async function loadPublicCampaignPageResumeData({ params }) {
  const campaignToken = params.campaignToken
  const { data, error } = await resumePublicCampaignShares({ campaignToken })
  if (error) {
    throw redirect(publicCampaignPagePath(campaignToken), { replace: true })
  }
  if (data?.OAuthRequired) {
    throw redirect(data.OAuthRedirectURL)
  }
  const tab = data?.SocialMediaShares?.length > 0 ? PUBLIC_CAMPAIGN_TAB.SHARED : PUBLIC_CAMPAIGN_TAB.NEW
  throw redirect(publicCampaignPagePath(campaignToken, tab), { replace: true })
}
